import { useDispatch } from 'react-redux';
import { toggleLoader } from '../../Store/loader/loaderReducer';
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { getInit, getUstat } from '../../Api/UserInfoGetApi';
import { orgInfoAction } from '../../Store/OrgInfo/orgInfo_action';
import { getPathFromLocalStroage } from '../../utils';
import { integration_action } from '../../Store/Integrations/IntegrationAction';

const OrgInIt = ({ isFetched, prePath }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const orgId = prePath?.split('/')[1]?.split('c')[1] ?? location?.state?.org_id;

  useEffect(() => {
    fetchSignInit();
  }, []);

  const fetchSignInit = () => {
    let param = {};
    dispatch(toggleLoader(true));
    getUstat(param, (res) => {
      if (res?.data) {
        handleInitHandler();
      } else {
        window.open(process.env.REACT_APP_SIGUP, "_self");
      }
    }, (err) => {
      const dynamicKey = Object.keys(err?.response?.data).find(key => !["status", "success"].includes(key));
      const dynamicValue = dynamicKey ? err?.response?.data[dynamicKey].details : null;
      toast.error(dynamicValue || "An unexpected error occurred. Please try again later.");
      dispatch(toggleLoader(false));
    });
  };

  const handleInitHandler = () => {
    let param = orgId ? { org_id: orgId } : {};

    dispatch(orgInfoAction(null));
    getInit(param, (response) => {
      let data = response?.data;
      dispatch(orgInfoAction(data));
      dispatch(toggleLoader(false));
      // let mergedArray = [...data?.integration_information, ...response?.data?.CRM_Integration_Info];
      let list = { integration_information: data?.integration_information, is_connected: true }
      dispatch(integration_action(list));
      isFetched(true);
      const id = data?.default_organizations?.Id ? `c${data?.default_organizations?.Id}` : '';
      let url_ = prePath?.replace(prePath?.split('/')[1], id);
      const pathLocal = getPathFromLocalStroage();
      if (prePath === '/') {
        pathLocal.path ? navigate(`${id}${pathLocal.path}`) : navigate(`${id}/post/drafts`);
      } else {
        navigate(url_);
      };
    }, (e) => {
      dispatch(toggleLoader(false));
      if (e?.response?.data?.error?.status === 403 && e?.response?.data?.error?.message === 'feature_access_denied') {
        navigate('/error-404');
      } else if (e.response.data.message === 'org_not_found' && !orgId) {
        window.open(process.env.REACT_APP_ACCOUNT, '_self');
      } else if (e.response.data.message === 'org_not_found' && orgId) {
        window.open(process.env.REACT_APP_URL, '_self');
      } else {
        const dynamicKey = Object.keys(e?.response?.data).find(key => !["status", "success"].includes(key));
        const dynamicValue = dynamicKey ? e?.response?.data[dynamicKey] : null;
        toast.error(dynamicValue || "An unexpected error occurred. Please try again later.");
      }
    });
  };
};

export default OrgInIt;